module.exports = __webpack_public_path__ + "img/order.8e71fb7c.svg";